/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback, useMemo, useState } from 'react';
import './AgentActions.scss';
import { KebabMenuIcon } from '../../../images/svg';
import { Modal } from '../../../UiKit';
import { getBlinkitActionsList } from './atoms/utils';
import {
  KEBAB_MENU_EVENTS,
  sendKebabMenuEvents,
} from '../../../helpers/analytics/kebabMenu.analytics';
import KebabItemsMenu from './KebabItemsMenu';
import { popUpClosedEvent, popUpOpenendEvent } from '../../../analytics/events';
import {
  EventType,
  FeatureName,
  MetricsForJumboEvent,
} from '../../../analytics/constants';

export const AgentActionsV1 = ({
  orderId = null,
  userId = null,
  isNewUser = false,
}) => {
  const [isMenuVisible, setMenuVisibility] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalVisible, setModalVisibility] = useState(false);

  const kebabMenuEventDetails = useMemo(
    () => ({
      event_type: EventType.CLICK,
      feature_name: FeatureName.KEBAB_MENU,
      [MetricsForJumboEvent.order_id]: orderId,
      [MetricsForJumboEvent.customer_id]: userId,
    }),
    [orderId, userId],
  );

  const openActionsMenu = useCallback(() => {
    popUpOpenendEvent(kebabMenuEventDetails);
    setMenuVisibility(true);
  }, [kebabMenuEventDetails]);

  const closeActionsMenu = useCallback(() => {
    popUpClosedEvent(kebabMenuEventDetails);
    setMenuVisibility(false);
  }, [kebabMenuEventDetails]);

  const onSelectMenuItem = useCallback(
    (item) => {
      sendKebabMenuEvents(
        KEBAB_MENU_EVENTS.KEBAB_MENU_SELECTED_ITEM,
        orderId,
        userId,
        { selected_item: String(item?.title) },
      );
      closeActionsMenu();
      if (item.type === 'link' && item.url) {
        window.open(item.url, '_blank');
        return;
      }
      const blinkitItem = getBlinkitActionsList.find(
        (i) => i.slug === item.slug,
      );
      setSelectedItem(blinkitItem);
      sendKebabMenuEvents(
        KEBAB_MENU_EVENTS.KEBAB_MENU_MODAL_OPEN,
        orderId,
        userId,
        { item: String(item.title) },
      );
      setModalVisibility(true);
    },
    [orderId, userId, closeActionsMenu],
  );

  const closeModal = useCallback(() => {
    sendKebabMenuEvents(
      KEBAB_MENU_EVENTS.KEBAB_MENU_MODAL_CLOSE,
      orderId,
      userId,
      { item: String(selectedItem.title) },
    );
    setModalVisibility(false);
    setSelectedItem(null);
  }, [orderId, userId, selectedItem]);

  const renderPopup = useCallback(() => {
    if (!selectedItem) return;
    const Comp = getBlinkitActionsList.find(
      (item) => item.slug === selectedItem.slug,
    ).value;
    return (
      <Comp
        orderId={orderId}
        userId={userId}
        isNewUser={isNewUser}
        item={selectedItem}
        closePopup={closeModal}
      />
    );
  }, [orderId, userId, isNewUser, selectedItem, closeModal]);

  return (
    <div
      className=' agentActions tw-relative tw-flex tw-items-center tw-justify-center tw-h-11 tw-rounded-[8px] tw-aspect-square tw-border-solid tw-border-[0.5px] tw-border-[#CFCFCF] tw-cursor-pointer hover:tw-bg-[#F5F5F5] tw-transition-all tw-duration-300 '
      onClick={() => openActionsMenu()}
    >
      <div
        className='menuIcon tw-flex tw-items-center tw-justify-center tw-h-full '
        onClick={() => openActionsMenu()}
      >
        {KebabMenuIcon}
      </div>

      {/* Kebab Menu */}
      <KebabItemsMenu
        isMenuVisible={isMenuVisible}
        closeActionsMenu={closeActionsMenu}
        onSelectMenuItem={onSelectMenuItem}
        orderId={orderId}
        userId={userId}
      />

      {isModalVisible && (
        <div>
          <Modal
            isVisible={isModalVisible}
            title={
              selectedItem?.heading ? (
                selectedItem.titleStyle ? (
                  <div style={{ ...selectedItem.titleStyle }}>
                    {selectedItem.heading}
                  </div>
                ) : (
                  <>{selectedItem.heading}</>
                )
              ) : (
                'Agent Action'
              )
            }
            type={(selectedItem && selectedItem.modalType) || 'large'}
            handleClose={closeModal}
            component={renderPopup()}
            minHeight={(selectedItem && selectedItem.minHeight) || '300px'}
            maxHeight={(selectedItem && selectedItem.maxHeight) || '300px'}
            paddingTop={(selectedItem && selectedItem.paddingTop) || '20px'}
            containerStyles={
              (selectedItem && selectedItem.containerStyles) || {}
            }
            showScrollBar={selectedItem?.showScrollBar}
          />
        </div>
      )}
      {/* </div> */}
    </div>
  );
};
